import {sortBy} from "lodash"
import {getAverageScore} from "@irati/insights/helpers/question"

/** Initial helper reference */
const helper = {}

/**
 *
 * Helper to run common requests
 * @param questionsByDriver
 * @returns {[array]}
 */

helper.driverAnswerAverage = (questionsByDriver) => {
  return questionsByDriver.map((driverQuestions) => {
    const driverId = driverQuestions.driver.id
    const name = driverQuestions.driver.name
    const contentId = driverQuestions.driver.contentId
    const score = getAverageScore(driverQuestions.questions)
    return {driverId, contentId, name, score}
  })
}


helper.descendingOrderDriverScores = (questionsByDriver) => {
  return sortBy(helper.driverAnswerAverage(questionsByDriver), ["score"]).reverse()
}

export const driverAnswerAverage = helper.driverAnswerAverage
export const descendingOrderDriverScores = helper.descendingOrderDriverScores


/** export default helper obj */
export default helper
